import styles from "./footer.module.css";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <p>
        Made by{" "}
        <a href="https://slime-fascinator-9f0.notion.site/Jisu-Yim-e121a093ce634e8c8df323ad8ff5260e">
          임지수
        </a>
      </p>
      <a href="https://forms.gle/79kW7Q6zSNtBqrfKA">피드백을 남겨주세요</a>
    </div>
  );
};

export default Footer;
